import Zendesk from "react-zendesk";

export function zendDeskChat(ZENDESK_ID: string | null | undefined) {
  if (ZENDESK_ID) {
    return <Zendesk defer zendeskKey={"2b06c8f6-c4a0-4925-ad38-68225e65f7d7"} />;
  } else {
    return <></>;
  }
}
